<template>
    <div id="vms-login" class="apply-bootstrap">
        <div class="container">
            <div class="row" id="vms-login-form">
                <div id="ecLogo">
                    <img alt="eCoordinator Login Page" src="https://dev.samaritan.com/coordinator/xsl/images/eCLogo.png?1">
                </div>
                <div>
                    <layout-container c-id="layoutContainer_VMS_Login"></layout-container>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineAsyncComponent } from "@common/defineAsyncComponent";
import "@common/syncfusionCss";
import { router } from "@common/router/router";

const vmsLoginCmp = {
    components: {
        layoutContainer: defineAsyncComponent(() => import('@common/layoutContainer/layoutContainer.vue')),
        loginForm: defineAsyncComponent(() => import('@common/loginForm/loginForm.vue'))
    },
    methods: {
        processAction: async function (act) {
            switch (act) {
                case 'login':
                    router.replace({ path: '/' });
                    break;
            }
        },
    }
};

export default vmsLoginCmp;
</script>

<style lang="css">

#vms-login h1, #vms-login .h1 {
    font-size: 32px;
    font-weight: 400;
}

#vms-login label {
    margin-bottom: 0;
    font-size: 14px !important;
    font-weight: 600;
    min-width: 80px;
    text-align: left;
}

#vms-login button, #vms-login input, #vms-login select, #vms-login textarea {
    background-color: transparent;
    border-style: none;
}

#vms-login .e-input {
    border-bottom-width: 0px;
    padding: 3px 5px;
}

#vms-login button {
    text-transform: none !important;
}

#vms-login {
    text-align: center;
    /*font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    margin: 0;*/
}

#vms-login .custom-message-container {
    width: 100%;
}

#vms-login-form {
    width: 490px;
    max-width: 90%;
    margin: 0 auto;
}

#vms-login #celebrationMessage {
    margin: 10px 0;
    color: #303030;
    font-size: 13px;
}

#vms-login #ecLogo {
    margin: 0 auto;
}

</style>
